import jsPDF from 'jspdf';
import { TestResults } from '../../../../types';
import { PageManager } from '../../helpers/pageBreaks';
import { SectionHeaderComponent } from './SectionHeader';
import { ExecutiveSummaryComponent } from './ExecutiveSummary';
import { PriorityRecommendationsComponent } from './PriorityRecommendations';
import { ImplementationRoadmapComponent } from './ImplementationRoadmap';
import { ResourcesSupportComponent } from './ResourcesSupport';

export class RecommendationsComponent {
  private pdf: jsPDF;
  private pageManager: PageManager;
  private sectionHeader: SectionHeaderComponent;
  private executiveSummary: ExecutiveSummaryComponent;
  private priorityRecommendations: PriorityRecommendationsComponent;
  private implementationRoadmap: ImplementationRoadmapComponent;
  private resourcesSupport: ResourcesSupportComponent;

  constructor(pdf: jsPDF, pageManager: PageManager) {
    this.pdf = pdf;
    this.pageManager = pageManager;
    
    // Initialize subcomponents
    this.sectionHeader = new SectionHeaderComponent(pdf, pageManager);
    this.executiveSummary = new ExecutiveSummaryComponent(pdf, pageManager);
    this.priorityRecommendations = new PriorityRecommendationsComponent(pdf, pageManager);
    this.implementationRoadmap = new ImplementationRoadmapComponent(pdf, pageManager);
    this.resourcesSupport = new ResourcesSupportComponent(pdf, pageManager);
  }

  generate(results: TestResults): void {
    this.sectionHeader.render();
    this.executiveSummary.render(results);
    this.priorityRecommendations.render(results);
    this.implementationRoadmap.render(results);
    this.resourcesSupport.render(results);
  }
}